import { createSelector } from '@ngrx/store';

import * as fromReducers from '../reducers';

export const getSqlQueryDetailsState = createSelector(fromReducers.getSqlQueryState, (state: fromReducers.SqlQueryState) => state.details);

export const getSqlQueryResponse = createSelector(getSqlQueryDetailsState, (state: fromReducers.SqlQueryDetailsState) => state.queryResonse);
export const getTableSchemas = createSelector(getSqlQueryDetailsState, (state: fromReducers.SqlQueryDetailsState) => state.tableSchemas);
